module.exports = __webpack_public_path__ + "img/1-06h.f56c57ea.png";